import { RouteInterface } from '@/src/common/enums/routes'
import { DesignSystem } from '@/src/design-system'
import { useMediaQuery } from 'react-responsive'
import { H3, ScrollView, View, YStack } from 'tamagui'
import * as E2E from '../e2e'
import { BackButton } from '@/src/common/components/BackButton'
import { Platform } from 'react-native'
import { Button } from '@/src/common/components/Button'
import type { ComponentProps } from 'react'

function Header({ previousRoute }: { previousRoute?: RouteInterface }) {
  const showBackButton = previousRoute && Platform.OS !== 'web'

  if (!showBackButton) {
    return null
  }

  return (
    <View mb="$5">
      <BackButton href={previousRoute.route} text="Back" testID={E2E.Config.Ids.Press.BackButton} />
    </View>
  )
}

function Content({
  children,
  title,
  titleAlignment,
}: {
  children: React.ReactNode
  title: string
  titleAlignment?: 'left' | 'center'
}) {
  return (
    <ScrollView flex={1} keyboardShouldPersistTaps="handled">
      <YStack gap="$4" flex={1}>
        <H3 text={titleAlignment}>{title}</H3>
        {children}
      </YStack>
    </ScrollView>
  )
}

function Container({ children }: { children: React.ReactNode }) {
  const isFixedWidthViewport = useMediaQuery({ minWidth: 720 })

  return (
    <DesignSystem.Container.KeyboardAvoidingView
      innerContainerStyle={{
        marginHorizontal: 0,
      }}
      style={{
        flex: 1,
        width: isFixedWidthViewport ? 500 : '100%',
        marginHorizontal: isFixedWidthViewport ? 'auto' : 0,
      }}
    >
      <View flex={1} maxW={isFixedWidthViewport ? 500 : '100%'} width="100%">
        {children}
      </View>
    </DesignSystem.Container.KeyboardAvoidingView>
  )
}

function SubmitButton({
  disabled,
  onPress,
  loading,
  ...props
}: {
  disabled?: boolean
  onPress: () => void
  loading?: boolean
} & (Pick<ComponentProps<typeof Button>, 'title'> | { children: React.ReactNode })) {
  return (
    <View pt="$4">
      <Button
        onPress={onPress}
        disabled={disabled || loading}
        loading={loading}
        mt="$4"
        {...props}
      />
    </View>
  )
}

export const ApplicationScreen = Object.assign(
  ({ children }: { children: React.ReactNode }) => <Container>{children}</Container>,
  { Header, Content, SubmitButton },
)
